import React from 'react'
import Icon from '../../../../Icon2/Icon'

import styles from './styles.module.css'

interface AssetBreadCrumbItem {
  uid: string;
  displayName: string;
  action: (breadCrumbIndex: number, uid: string) => void
}

export function AssetBreadCrumb({ breadcrumbs }: { breadcrumbs: AssetBreadCrumbItem[] }) {
  return (
    <div className={styles['breadcrumb']}>
      <Icon icon='Folder' className={styles['mr-5']} />
      {breadcrumbs.map((item, idx) => (
        <span key={item.uid} style={{ cursor: 'pointer' }} onClick={() => item.action(idx, item.uid)}>
          {item.displayName} /&nbsp;
        </span>
      ))}
    </div>
  )
}
